import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from '@/components/ui/card';

import { ChargeTable } from './table';

export function Charges() {
	return (
		<>
			<Card className="w-full">
				<CardHeader>
					<span className="flex flex-row justify-between">
						<CardTitle className="mt-2">Charges</CardTitle>
					</span>
				</CardHeader>
				<CardContent className="space-y-2">
					<ChargeTable />
				</CardContent>
			</Card>
		</>
	);
}
